import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface FooterProps {
  className?: string;
}

export function Footer({ className }: FooterProps) {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { title: 'Home', href: '/' },
    { title: 'Events', href: '/events' },
    { title: 'Find Your Club', href: '/find-club' },
    { title: 'Coach & Parent Admin', href: '/coach-auth' },
    { title: 'Admin', href: '/admin/auth' },
  ];

  const legalLinks = [
    { title: 'Terms and Conditions', href: '/terms-conditions' },
    { title: 'Privacy Policy', href: '/privacy-policy' },
    { title: 'Contact', href: '/contact-us' },
  ];

  return (
    <footer className={cn("bg-muted/30 border-t border-border/50 mt-auto", className)}>
      <div className="container mx-auto px-4 py-12">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between gap-8 mb-8">
          {/* Logo & Description */}
          <div className="max-w-sm">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://lztlmniinqehhxbqftsn.supabase.co/storage/v1/object/public/badge-icons/FutWork_Primary%20Logo-01.png" 
                alt="FutWork Logo" 
                className="h-8"
              />
            </Link>
            <p className="text-sm text-muted-foreground">
              The ultimate soccer skills training platform. Train smarter, track progress, and level up your game.
            </p>
          </div>

          {/* Navigation Links */}
          <div className="flex flex-col sm:flex-row gap-8">
            <div>
              <h3 className="font-semibold text-foreground mb-3 text-sm">Navigation</h3>
              <div className="flex flex-col gap-2">
                {navLinks.map((link) => (
                  <Link 
                    key={link.href}
                    to={link.href} 
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.title}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h3 className="font-semibold text-foreground mb-3 text-sm">Legal</h3>
              <div className="flex flex-col gap-2">
                {legalLinks.map((link) => (
                  <Link 
                    key={link.href}
                    to={link.href} 
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.title}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-border/50">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-muted-foreground">
            <span>© {currentYear} FutWork. All rights reserved.</span>
            <span>v1.0.0</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
